module.exports = __webpack_public_path__ + "img/table.187a869d.svg";